module.exports = __webpack_public_path__ + "static/vickyubaldo-6040a441e0be746fcd5279efa7da04b9.jpg";